var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f-model",
    _vm._g(
      _vm._b(
        {
          staticClass: "f-media",
          attrs: {
            model: "Media",
            collection: "Media",
            "custom-label": _vm.customLabel,
            "option-title": "title",
            "option-description": "caption",
          },
          scopedSlots: _vm._u([
            {
              key: "singleLabel",
              fn: function (ref) {
                var title = ref.title
                return [
                  _c("div", {
                    staticClass: "title",
                    domProps: {
                      innerHTML: _vm._s((title && title.rendered) || ""),
                    },
                  }),
                ]
              },
            },
            {
              key: "option",
              fn: function (ref) {
                var title = ref.title
                var caption = ref.caption
                return [
                  _c("div", {
                    staticClass: "title",
                    domProps: {
                      innerHTML: _vm._s((title && title.rendered) || ""),
                    },
                  }),
                  _c("div", {
                    staticClass: "description",
                    domProps: {
                      innerHTML: _vm._s((caption && caption.rendered) || ""),
                    },
                  }),
                ]
              },
            },
          ]),
        },
        "f-model",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }